import dayjs from "dayjs";
import * as customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
export const DEFAULT_DISPLAY_FORMAT = "DD MMMM, YYYY";
export const DEFAULT_DATETIME_DISPLAY_FORMAT = "DD MMMM, YYYY, h:mm a";

export const formatDateToString = (
  date,
  format = DEFAULT_DATE_FORMAT,
  parseFormat = undefined
) => {
  return dayjs(date, parseFormat).format(format);
};

export const parseDate = (dateString, parseFormat = undefined) => {
  return dayjs(dateString, parseFormat);
};

export const getDateDifference = (newDate, oldDate, unit) => {
  return dayjs(newDate).diff(oldDate, unit);
};

export const isDateBefore = (beforeDate, afterDate) => {
  return dayjs(beforeDate).isAfter(afterDate);
};

const describeDateShort = (seconds, includeSeconds = false) => {
  // pass in date param as seconds
  // Define the time units in seconds
  const timeUnits = [
    { unit: "Y", value: 60 * 60 * 24 * 365, label: "Year" }, // Year
    { unit: "M", value: 60 * 60 * 24 * 30, label: "Month" }, // Month (approx)
    { unit: "D", value: 60 * 60 * 24, label: "Day" }, // Day
    { unit: "H", value: 60 * 60, label: "Hour" }, // Hour
    { unit: "M", value: 60, label: "Min" }, // Minute
  ];
  if (includeSeconds) timeUnits.push({ unit: "S", value: 1, label: "Sec" }); // Second

  let remainingSeconds = seconds;
  const result = [];

  for (const { unit, value } of timeUnits) {
    if (remainingSeconds >= value) {
      const count = Math.floor(remainingSeconds / value);
      result.push(`${count}${unit}`);
      remainingSeconds %= value;
    }
  }

  // If the input seconds were 0, return "0S"
  if (result.length === 0 || seconds <= 0) return "0S";

  return result.join("");
};

export const describeDate = (seconds, maxLength = 30, includeSeconds = false) => {
  // Define the time units in seconds
  const timeUnits = [
    { unit: "Year", value: 60 * 60 * 24 * 365 },
    { unit: "Month", value: 60 * 60 * 24 * 30 },
    { unit: "Day", value: 60 * 60 * 24 },
    { unit: "Hour", value: 60 * 60 },
    { unit: "Min", value: 60 },
  ];
  if (includeSeconds) timeUnits.push({ unit: "Sec", value: 1 }); // Second

  let remainingSeconds = seconds;
  const result = [];

  for (const { unit, value } of timeUnits) {
    if (remainingSeconds >= value) {
      const count = Math.floor(remainingSeconds / value);
      result.push(`${count} ${unit}${count > 1 ? "s" : ""}`);
      remainingSeconds %= value;
    }
  }

  // If the input seconds were 0, return "0 Sec"
  if (result.length === 0 || seconds <= 0) return "0 Sec";
  const response = result.join(" ");
  if (response.length > maxLength) return describeDateShort(seconds, includeSeconds);
  else return response;
};
